import React from "react";
import { Box, Typography, Grid, Link } from "@mui/material";

import CerebralZip from "../../assets/images/watermark/cerebralzip-logo.svg";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        position: "relative",
        backgroundColor: "#0a1a2d",
        color: "white",
        py: 4,
        px: { xs: 2, sm: 4 },
        overflow: "hidden",
      }}
    >
      <Grid container spacing={3}>
        {/* Left Section - Contact and Powered By */}
        <Grid item xs={12} sm={6} md={6}>
          <Typography
            variant="h6"
            sx={{ fontSize: "16px", fontWeight: "bold", mb: 1 }}
          >
            General Administration Department
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: "0.9rem", color: "#ffffff" , display: "flex" }}
          >
            महाराष्ट्र शासन
          <Typography
            variant="body1"
            sx={{ fontSize: "1rem", color: "#ffffff" , ml: "1rem", pl: "1rem", borderLeft: "1px solid white" }}
          >
            Government of Maharashtra
          </Typography>
          </Typography>


          {/* Powered By Section */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="body2" sx={{ color: "lightgray" }}>
              Powered By:
            </Typography>
          </Box>

          {/* Watermark Section */}
          <Box
            sx={{
              mt: 1,
              opacity: 1,
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={CerebralZip}
              alt="Watermark Logo"
              style={{ width: "30px", height: "auto", marginRight: "10px" }}
            />
            <Typography
              variant="h6"
              sx={{ fontSize: "1rem", fontWeight: "bold", color: "white" }}
            >
              CerebralZip
            </Typography>
          </Box>
        </Grid>

        {/* Menu Sections */}
        <Grid item xs={12} sm={6} md={6} display={"flex"} flexDirection={"column"} alignItems={"flex-start" } justifyContent={"end"}>
        <Typography
            variant="body2"
            sx={{ mt: 2, fontSize: "0.9rem", color: "lightgray" }}
          >
            Contact:{" "}
            <Link href="mailto:gadmaharashtra@gov.in" color="inherit">
              gadmaharashtra@gov.in
            </Link>
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontSize: "0.85rem", color: "lightgray", mt: 1 }}
          >
            Legal Disclaimer: Website belongs to GAD Maharashtra | ©2024 |
            Rights reserved
          </Typography>

        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;